import React, { useCallback, useEffect } from 'react';
import { ProductsFeedsTable } from '../../components/tables/products-feeds/ProductsFeedsTable';
import { useDispatch, useSelector } from 'react-redux';
import { useUploadProductsPermissions } from '../../hooks/useUploadProductsPermission';
import {
  fetchProductsFeeds,
  setProductsFeedsPage,
  setProductsFeedsRowsPerPage,
} from '../../store/actions/productsFeeds';
import Pagination, { PaginationWrapper, RowsPerPage } from '../../components/common/Pagination';
import { productsFeedsRowsPerPage } from '../../constants/productsFeeds';
import { ProductsFeedsActions } from '../blocks/ProductsFeeds/ProductsFeedsActions';

export function ProductsFeeds() {
  const dispatch = useDispatch();
  const { isUploadProductsEnabled } = useUploadProductsPermissions();

  const {
    totalCount,
    table: { rowsPerPage, page },
  } = useSelector((state) => state.productsFeeds);

  const updateFeeds = useCallback(() => {
    dispatch(fetchProductsFeeds());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    updateFeeds();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setRowsPerPage = (newRowsPerPage) => {
    dispatch(setProductsFeedsRowsPerPage(newRowsPerPage));
    updateFeeds();
  };

  const setPage = (newPage) => {
    dispatch(setProductsFeedsPage(newPage));
    updateFeeds();
  };

  return (
    <>
      {isUploadProductsEnabled && <ProductsFeedsActions />}

      <ProductsFeedsTable />

      <PaginationWrapper>
        <RowsPerPage options={productsFeedsRowsPerPage} current={rowsPerPage} onChange={setRowsPerPage} />
        <Pagination
          pageCount={Math.ceil(totalCount / rowsPerPage)}
          handlePageClick={({ selected }) => setPage(selected)}
          currentPage={page}
        />
      </PaginationWrapper>
    </>
  );
}
